import { render, staticRenderFns } from "./AssetDelete.vue?vue&type=template&id=72716452&scoped=true&"
import script from "./AssetDelete.vue?vue&type=script&lang=js&"
export * from "./AssetDelete.vue?vue&type=script&lang=js&"
import style0 from "./AssetDelete.vue?vue&type=style&index=0&id=72716452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72716452",
  null
  
)

export default component.exports